import { useState, useEffect } from 'react';
import { api } from '../services/api';
import type { ProblemWithAngles } from '@attack100/shared';

export function useProblem(id: number) {
  const [problem, setProblem] = useState<ProblemWithAngles | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProblem = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await api.getProblem(id);
      setProblem(data.problem);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch problem');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProblem();
  }, [id]);

  return { problem, loading, error, refetch: fetchProblem };
}
